
import {View} from 'backbone';
import template from 'dashboard/connections/details/connection-web-services.ejs';
import ConnectionResearchView from 'dashboard/connections/details/ConnectionResearchView';
import RestService from 'RestService';
import xJService from 'xml/XJService';
import NotificationService from 'NotificationService.js';
import util from 'util/Util';
class ConnectionWebServices extends View {
    initialize(opts){

        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'change input[name=_url],input[name=_implType],input[name=_wsdlUrl],input[name=_username],input[name=_password], input[name=CertificatePassphrase]': 'processConnectionInputs',
            'change input[name=_urlencoded],input[name=_useProxy],input[name=_useNameSpace]': 'processConnectionCheckboxes',
            'click input[name=checkConnection]': 'checkConnection',
            'change select[name=_implType]': 'changeImplType',
            'click #wsdlFinder': 'findServiceUrl',
            'change input[name=_wsdlSource]' : 'processWSDLSource',
            'change #wsSources': 'setNewSource',
            'click .refresh-wssource': 'refreshSources'
        };

        this.listenTo(this.model, 'change', this.render);
    
        return this;
    }

    refreshSources(){
        this.connectionService.loadWSSources(true);
    }

    setNewSource(ev){
        this.connectionService.setNewSource(ev);
    }

    processWSDLSource(ev) {
        let currentModel = this.model.get('currentConnectionDetails');
        currentModel.ConnectionXML.Connection[ev.target.name] = ev.target.value;
        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('wsdlSource', ev.target.value);
        this.model.set('hasChanges', true);
    }

    findServiceUrl(){
        const currentConnectionDetails = this.model.get('currentConnectionDetails');
        const wsdlUrl = currentConnectionDetails.ConnectionXML.Connection['_wsdlUrl'];
        const _username = currentConnectionDetails.ConnectionXML.Connection['_username'];
        const _password = currentConnectionDetails.ConnectionXML.Connection['_password'];
        const _useNameSpace = true; //Need to be true in order to retrieve all the elements regarding the actual value on Connection
        const _useNameSpaceOperation = 'URL';

       
        let getWSDLParams = { username: _username, password: _password, useNameSpace: _useNameSpace, useNameSpaceOperation: _useNameSpaceOperation  };

        const _wsdlFile =  currentConnectionDetails.wsdlFile;
        const _wsdlFileName = currentConnectionDetails.WsdlFileName;
        const _wsdlSource = currentConnectionDetails.ConnectionXML.Connection['_wsdlSource'];
        
        //PF-10915 If it has a file don't send URL
        if(_wsdlSource === "file"){
            getWSDLParams.wsdlFile = _wsdlFile;
            getWSDLParams.WsdlFileName = _wsdlFileName;
        }else{
            getWSDLParams.URL = wsdlUrl   
        }

        const _certificateFile =  currentConnectionDetails.CertificateFile;
        const _certificateName = currentConnectionDetails.CertificateName;
      
        if(_certificateFile || _certificateName){
            getWSDLParams.certificateFile = _certificateFile;
            getWSDLParams.certificateName = _certificateName;
            getWSDLParams.certificatePassphrase = currentConnectionDetails.CertificatePassphrase || undefined;
        }

        getWSDLParams.connectionId = this.model.get('connectionId');
        
        RestService.getWSDL(getWSDLParams).then((data) => {
            let url = '';
            if (typeof data !== 'undefined' && data !== '') {
                const wsdlObj = xJService.toJSON(data);
                if (wsdlObj['URL']) {
                    url = wsdlObj.URL._location;
                } else if (wsdlObj['wsdl:definitions'] && wsdlObj['wsdl:definitions']['wsdl:service']
                    && wsdlObj['wsdl:definitions']['wsdl:service']['wsdl:port'] && wsdlObj['wsdl:definitions']['wsdl:service']['wsdl:port']) {
                    if ($.isArray(wsdlObj['wsdl:definitions']['wsdl:service']['wsdl:port'])) {
                        url = wsdlObj['wsdl:definitions']['wsdl:service']['wsdl:port'][0]['soap:address']._location;
                    } else {
                        url = wsdlObj['wsdl:definitions']['wsdl:service']['wsdl:port']['soap:address']._location;
                    }
                }
            } else {
                NotificationService.error('Invalid web service WSDL.');
            }

            currentConnectionDetails.ConnectionXML.Connection['_url'] = url;

            //Reset the source Id in case it exists
            if(currentConnectionDetails.WSSourceId){
                currentConnectionDetails.WSSourceId = null;
            }

            this.model.set('hasChanges', true);
            this.render();
        }).catch((err) => {
            NotificationService.error('Invalid web service WSDL.');
        });
    }

    changeImplType(e){
        const currentConnectionDetails = this.model.get('currentConnectionDetails');
        currentConnectionDetails.ConnectionXML.Connection['_implType'] = e.target.value;
        this.model.set('hasChanges', true);
        this.render();
    }

    processConnectionCheckboxes(){
        return this.connectionService.processConnectionCheckboxes.apply(this.connectionService, arguments);
    }

    processConnectionInputs(){
        return this.connectionService.processConnectionInputs.apply(this.connectionService, arguments);
    }

    checkConnection(){
        return this.connectionService.checkConnection.apply(this.connectionService, arguments);
    }

    loadWSDLFile(){
        const self = this;
        
        $('#wsdlfile-upload').on('change', (e) => {
            self.wsdlFile = $('#wsdlfile-upload')[0].files[0];
            self.connectionService.wsdlFile =  self.wsdlFile;
            self.processWSDLFile(e);
            self.findServiceUrl();
        });

        $("#wsdlfile-upload-label").off();

        $("#remove-wsdlfile").on('click', (e)=>{
            let confirmation = util.createDialogDeleteConfirmation("Remove WSDL File",
             "Are you sure you wish to remove the WSDL file for this connection?",
             true);
 
             confirmation.render().then((result) => {
                 if (result === 'Ok') {
                     self.processWSDLFile(e);
                 }
             });
         })

    }

    processWSDLFile(ev) {
        let currentModel = this.model.get('currentConnectionDetails');

        if (ev.target.id === 'wsdlfile-upload') {
            let fileName = ev.target.value.split('\\').pop();
            currentModel.WsdlFileName = fileName;
            currentModel.wsdlFile = this.wsdlFile;
        } else {
                currentModel.wsdlFile = null;
                currentModel.WsdlFileName = ''; 
        }
        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true);
        this.render();
    }

    render(){

        this.connectionService.validateCertificateExpiration();
        this.connectionService.associateToSource();
        
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const connectionResearchView = new ConnectionResearchView({el:'#connectionResearch', model:this.model });
        connectionResearchView.render();

        let connection = this.model.get('currentConnectionDetails');
        $('[name=_implType]').find("option[value='"+connection.ConnectionXML.Connection['_implType']+"']").attr('selected', true);

        this.connectionService.loadCertificateFileUpload();

        //LOad only if file is selected
        if (connection.ConnectionXML.Connection['_wsdlSource'] === "file") {
            this.loadWSDLFile();
        }

        this.connectionService.associateToSource();
      
        this.delegateEvents();
        return this;
    }

}

export default ConnectionWebServices;